import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { motion } from "framer-motion";
import "./Operations.css"; // Import custom styles if needed

const Operations = () => {
  return (
    <motion.div
      id="operations"
      className="container-fluid bg-black text-white d-flex align-items-center"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true, amount: 0.2 }}
    >
      <div className="container my-5">
        <div className="row align-items-center">
          {/* Image Section - Left Side */}
          <motion.div
            className="col-lg-6 text-center mt-4 mt-lg-0 order-lg-1"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
            viewport={{ once: true }}
          >
            <img
              src="iso.png" // Replace with actual image
              alt="Operations"
              className="img-op img-fluid rounded shadow w-75 mb-4"
            />
          </motion.div>

          {/* Text Section - Right Side */}
          <motion.div
            className="col-lg-6 order-lg-2"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h1 className="about-heading fw-bold mb-4">Our Operations</h1>

            <p>
              We are an <strong>ISO 9001:2015 certified company</strong>,
              committed to maintaining the highest standards in quality
              management and customer satisfaction. This internationally
              recognized certification ensures that our processes adhere to
              strict quality control measures, continuous improvement, and
              customer-centric solutions. Our focus is on delivering superior
              products and services while meeting regulatory requirements.
            </p>

            <p>
              Our operations encompass a wide range of activities, including
              state-of-the-art production processes, rigorous quality control,
              and a commitment to efficiency. By implementing the principles of
              ISO 9001:2015, we continuously enhance our operational
              effectiveness and ensure that our products exceed industry
              standards.
            </p>

            <p>
              Driven by a team of experts, we have successfully expanded our
              reach to global markets, serving clients across various industries
              with our high-quality products and innovative solutions. Our
              dedication to continuous improvement and customer satisfaction
              allows us to maintain a competitive edge in the industry.
            </p>

            {/* Read More Button */}
            <motion.button
              className="btn btn-danger"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              onClick={() => {
                window.open("/certi.pdf", "_blank"); // Opens in a new tab
              }}
            >
              View Certificate
            </motion.button>
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default Operations;
